export default __webpack_public_path__ + "static/media/virtualpad_bt_r.54657c01.png";